import { AddressFeatureState } from '../../../../../../../@types/state-types'
import { convertManualItem } from '../../../../../../../services/conversion/conversionServices'
import { RealEstateManualAddress } from '../../../../../../../@types/real-estate-api-types'
import { ContentStateInterface } from '../../../../../../../@types/types'
import { COUNTRY_CODE_GERMANY } from '../../../../../../../utils/geo-utils'

export const manualToApi = (
  addressFeature: AddressFeatureState,
  insertionData: ContentStateInterface
): { manual: RealEstateManualAddress } | undefined => {
  if (!addressFeature.hasValidGeoCoordinates && insertionData.manualQuarter?.geoCoordinates) {
    return {
      manual: {
        country: convertManualItem({ value: `${COUNTRY_CODE_GERMANY}`, label: 'Germany' }),
        region:
          insertionData.manualRegion?.value !== null && insertionData.manualRegion?.value !== undefined
            ? convertManualItem(insertionData.manualRegion)
            : { id: 0, name: '' },
        city:
          insertionData.manualCity?.value !== null && insertionData.manualCity?.value !== undefined
            ? convertManualItem(insertionData.manualCity)
            : { id: 0, name: '' },
        quarter: convertManualItem(insertionData.manualQuarter),
      },
    }
  } else if (
    insertionData.manualCountry?.value !== null &&
    insertionData.manualCountry?.value !== undefined &&
    insertionData.manualRegion?.value !== null &&
    insertionData.manualRegion?.value !== undefined
  ) {
    return {
      manual: {
        country: convertManualItem(insertionData.manualCountry),
        region: convertManualItem(insertionData.manualRegion),
        quarter: { id: 0 },
        city: { id: 0 },
      },
    }
  }
  return undefined
}
